//                                                           //
//  Program: RentalListingLookup.jsx                               //
//  Application: Rental United                               //
//  Option: Rental Lookup tables                             //
//  Developer: NP 		                                     //
//  Date: 2022-09-13                                         //
//                                                           //
/////////////////////////////////////////////////////////   ///

import React, { Component } from "react";
import RUSidebar from "../common/RUSidebar";
import Select from "react-select";
import { Container, Form } from "react-bootstrap";
import Alerts from "../common/Alerts";
import PropertyService from "../../services/PropertyService";
import ListingService from "../../services/ListingService";
import RentalService from "../../services/RentalService";
import SimpleReactValidator from "simple-react-validator";

class RentalListingLookup extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      input: {},
      errors: {},
      propertyList: [],
      newPropertyList:[],
      selectedPropertyList:[],
      property_slug: "",
      listing_slug:"",
      headline : "",
      why_purchased : "",
      owner_story : "",
      wi_fi : "",
      is_exempt : false,
      is_vat_registered : false,
      host_intraction : "",
    };
    this.saveData = this.saveData.bind(this);
  }

  componentDidMount(){
    this.getPropertyData();
  }

  async getPropertyData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var propertyList = [];
    var propertyListTotal = 0;
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
      propertyListTotal = propertyList ? propertyList.length : 0
    }
    const newPropertyList = propertyListTotal > 0 ? propertyList.map(({ slug, property_name }) => ({
      value: slug,
      label: property_name,
    })) : [];
    this.setState({ propertyList: propertyList, newPropertyList: newPropertyList, propertyListTotal: propertyListTotal });
    this.setState({ showSpinner: false, loading: false });
  }

  handleChangePropertyList(value) {
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }
    if(value){
        this.getListingData(value.value);   //get listing of selected property
    }
    this.setState({
      selectedPropertyList: value,
      property_slug: value.value,
    });
  }

  async getListingDetails(value) {
    if (value !== undefined) {
      var resData = {};

      let res = await ListingService.getListing(value);
      if (global.successStatus.includes(res.status)) {
        resData.is_exempt = res.data.ruListingData ? (res.data.ruListingData.is_exempt === 1 ? true : false) : false
        resData.is_vat_registered = res.data.ruListingData ? (res.data.ruListingData.is_vat_registered === 1 ? true : false) : false
        resData.headline = res.data.ruListingData ? res.data.ruListingData.headline : ""
        resData.why_purchased = res.data.ruListingData ? res.data.ruListingData.why_purchased : ""
        resData.owner_story = res.data.ruListingData ? res.data.ruListingData.owner_story : ""
        resData.wi_fi = res.data.ruListingData ? res.data.ruListingData.wi_fi : ""
        resData.host_intraction = res.data.ruListingData ? res.data.ruListingData.host_intraction : ""
      }
      this.setState(resData);
    }
  }

  async getListingData(value) {
    this.setState({ showSpinner: true, loading: true });
    var listingList = [];
    var listingListTotal = 0;
    let res = await ListingService.getListingList(
        "property_slug=" + value + "&is_dropdown=1"
    );
    if (global.successStatus.includes(res.status)) {
      listingList = res.data ? res.data : [];
      listingListTotal = listingList ? listingList.length : 0
    }
    const newListingList = listingListTotal > 0 ? listingList.map(({ slug, listing_name }) => ({
      value: slug,
      label: listing_name,
    })) : [];
    this.setState({ listingList: listingList, newListingList: newListingList, listingListTotal: listingListTotal });
    this.setState({ showSpinner: false, loading: false });
  }

  handleChangeListingList(value) {
    let listing_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        listing_slug.push(item.value);
      });
    }
    if(value){
      this.getListingDetails(value.value);
    }
    this.setState({
      selectedListingList: value,
      listing_slug: value.value
    });
  }

  changeHandler = (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    value = event.target.type === "radio" ? parseInt(value) : value;

    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });

    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();

    this.setState({ confirm_back: 1 });
  };

  customValidate() {
    let isValid = true;
    return isValid;
  }

  saveData = async (e) => {
    e.preventDefault();
    if (this.validator.allValid() && this.customValidate()) {
      this.setState({ showSpinner: true, isSubmit: true });
      let inputData = {
        property_slug: this.state.property_slug ? this.state.property_slug : "",
        listing_slug: this.state.listing_slug ? this.state.listing_slug : "",
        headline: this.state.headline ? this.state.headline : "",
        why_purchased: this.state.why_purchased ? this.state.why_purchased : "",
        owner_story: this.state.owner_story ? this.state.owner_story : "",
        wi_fi: this.state.wi_fi ? this.state.wi_fi : "",
        host_intraction: this.state.host_intraction ? this.state.host_intraction : "",
        is_exempt:this.state.is_exempt === true ? 1 : 0,
        is_vat_registered:this.state.is_vat_registered === true ? 1 : 0
      };
     
      let res = await RentalService.createListingData(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        // setTimeout(
        //   () =>
        //     this.props.history.push(
        //       "/properties/view/" +
        //       this.state.property_slug +
        //       "/guest/view/" +
        //       this.state.slug
        //     ),
        //   global.redirect_time
        // );
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
          alertModalMessage: res.data.message ? res.data.message : "Error!",
        });
      }
     
      this.setState({ showSpinner: false, isSubmit: false });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
      const input = document.getElementsByClassName("text-danger");
      if (input.length > 0) {
        input[0].scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        });
      }
    }
  };

  render() {
    const customStyles = {
        option: (provided, state) => ({
          ...provided,
          // color: state.isSelected ? 'black' : ((state.isSelected && state.isFocused) ? "white" : ( state.isFocused && 'white')),
          color: (state.isSelected && state.isFocused) ? "white" : (state.isSelected ? "black" : state.isFocused && "white"),
          backgroundColor: (state.isSelected && state.isFocused) ? 'black' : (state.isFocused && "black"),
        })
      }
    return (
      <>
        <main>
        {/* {this.state.showSpinner ? global.spinnerLoader : ""} */}
        <Container className="innter-container">
            <div className="d-flex flex-column">
            <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-2 left">
                <div className="child-menu-section">
                    <aside>
                    <RUSidebar />
                    </aside>
                </div>
                </div>
                <div className="col-md-10 right">
                <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                    <h3>Listing</h3>
                    <div className="d-flex justify-content-end">
                      {global.userPermissions.checkPermission('ru-integration-update') &&
                        <button
                        type="button"
                        className="btn-success ml-3"
                        onClick={this.saveData}
                        disabled={this.state.isSubmit ? true : false}
                        >
                        {this.state.isSubmit
                            ? global.loader
                            : "Save"}
                        </button>
                      }
                    </div>
                    </div>
                </div>
                <div className="scrolling-carousel pd-l-15">
                    <form id="units_form">
                    <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                        <div className="col-md-12 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-0 mg-t-0">
                        <Alerts
                            show={this.state.showAlertModal}
                            type={this.state.alertModalType}
                            title={this.state.alertModalTitle}
                            message={this.state.alertModalMessage}
                        />
                        </div>
                        <div className="m-0">
                        <div className="row align-items-center pd-b-0 border-bottom-0  pd-xs-l-0 pd-xs-r-0  pd-lg-l-0 pd-lg-r-15">
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Property{" "}
                            </label>
                            <Select
                            styles={customStyles}
                            className="multiselect"
                            classNamePrefix={"my-custom-react-select"}
                            menuPlacement="auto"
                            value={this.state.selectedPropertyList}
                            options={this.state.newPropertyList}
                            getOptionValue={option => `${option.label}`}
                            onChange={(value) => this.handleChangePropertyList(value)}
                            defaultValue={this.state.selectedPropertyList}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 2,
                              colors: {
                                ...theme.colors,
                                primary: '#fff',
                                primary75: '#000',
                                primary50: '#000',
                                primary25: '#000',
                              }
                            })}
                          />
                            {this.state.errors.property_slug ? (
                                <div className="text-danger">
                                {this.state.errors.property_slug}
                                </div>
                            ) : (
                                this.validator.message(
                                "property",
                                this.state.property_slug,
                                "required",
                                { className: "text-danger" }
                                )
                            )}
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Listing{" "}
                            </label>
                            <Select
                              styles={customStyles}
                              isClearable={true}
                              className="multiselect"
                              classNamePrefix={"my-custom-react-select"}
                              menuPlacement="auto"
                              value={this.state.selectedListingList || ""}
                              options={this.state.newListingList}
                              onChange={(value) =>
                                this.handleChangeListingList(value)
                              }
                              defaultValue={this.state.selectedListingList}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 2,
                                colors: {
                                  ...theme.colors,
                                  primary: "#fff",
                                  primary75: "#000",
                                  primary50: "#000",
                                  primary25: "#000",
                                },
                              })}
                            />
                            {this.state.errors.listing_slug ? (
                              <div className="text-danger">
                                {this.state.errors.listing_slug}
                              </div>
                            ) : (
                              this.validator.message(
                                "listing",
                                this.state.listing_slug,
                                "required",
                                { className: "text-danger" }
                              )
                            )}
                            </div>
                        </div>
                        {this.state.property_slug && this.state.listing_slug ?
                        <div className="row align-items-center pd-b-0 border-bottom-0  pd-xs-l-0 pd-xs-r-0  pd-lg-l-0 pd-lg-r-15">
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Headline{" "}
                                <span className="optional">(Optional)</span>
                            </label>
                            <Form.Control
                                type="text"
                                onChange={this.changeHandler}
                                name="headline"
                                value={this.state.headline}
                                maxLength="50"
                            />
                            {this.state.errors.headline ? (
                                <div className="text-danger">
                                {this.state.errors.headline}
                                </div>
                            ) : (
                                this.validator.message(
                                "headline",
                                this.state.headline,
                                "max:50",
                                { className: "text-danger" }
                                )
                            )}
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                              Why Purchased{" "}
                              <span className="optional">(Optional)</span>
                            </label>
                            <Form.Control
                                type="text"
                                onChange={this.changeHandler}
                                name="why_purchased"
                                value={this.state.why_purchased}
                                maxLength="1000"
                                as="textarea"
                            />
                            {this.state.errors.why_purchased ? (
                                <div className="text-danger">
                                {this.state.errors.why_purchased}
                                </div>
                            ) : (
                                this.validator.message(
                                "why_purchased",
                                this.state.why_purchased,
                                "max:1000",
                                { className: "text-danger" }
                                )
                            )}
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Owner Story{" "}
                                <span className="optional">(Optional)</span>
                            </label>
                            <Form.Control
                                type="text"
                                onChange={this.changeHandler}
                                name="owner_story"
                                value={this.state.owner_story}
                                maxLength="500"
                                as="textarea"
                            />
                            {this.state.errors.owner_story ? (
                                <div className="text-danger">
                                {this.state.errors.owner_story}
                                </div>
                            ) : (
                                this.validator.message(
                                "owner_story",
                                this.state.owner_story,
                                "max:500",
                                { className: "text-danger" }
                                )
                            )}
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Host Interaction{" "}
                                <span className="optional">(Optional)</span>
                            </label>
                            <Form.Control
                                type="text"
                                onChange={this.changeHandler}
                                name="host_intraction"
                                value={this.state.host_intraction}
                                maxLength="500"
                                as="textarea"
                            />
                            {this.state.errors.host_intraction ? (
                                <div className="text-danger">
                                {this.state.errors.host_intraction}
                                </div>
                            ) : (
                                this.validator.message(
                                "host_intraction",
                                this.state.host_intraction,
                                "max:500",
                                { className: "text-danger" }
                                )
                            )}
                            </div>
                            {/* <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Wi-Fi{" "}
                                <span className="optional">(Optional)</span>
                            </label>
                            <Form.Control
                                type="text"
                                onChange={this.changeHandler}
                                name="wi_fi"
                                value={this.state.wi_fi}
                                maxLength="50"
                            />
                            {this.state.errors.wi_fi ? (
                                <div className="text-danger">
                                {this.state.errors.wi_fi}
                                </div>
                            ) : (
                                this.validator.message(
                                "wi_fi",
                                this.state.wi_fi,
                                "max:50",
                                { className: "text-danger" }
                                )
                            )}
                            </div> */}
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                Exempt
                            </label>
                              <Form.Check
                                name="is_exempt"
                                type={"checkbox"}
                                id={`is_exempt`}
                                label=""
                                className={"ckbox"}
                                onChange={this.changeHandler}
                                checked={this.state.is_exempt}
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                            <label className="form-label text-left pd-b-5">
                                VAT Registered
                            </label>
                              <Form.Check
                                name="is_vat_registered"
                                type={"checkbox"}
                                id={`is_vat_registered`}
                                label=""
                                className={"ckbox"}
                                onChange={this.changeHandler}
                                checked={this.state.is_vat_registered}
                              />
                            {this.state.errors.email ? (
                                <div className="text-danger">
                                {this.state.errors.email}
                                </div>
                            ) : (
                                this.validator.message(
                                "email",
                                this.state.email,
                                "email|max:50",
                                { className: "text-danger" }
                                )
                            )}
                            </div>
                        </div>
                        : ''}
                        </div>
                    </div>
                    </form>
                </div>
                </div>
            </div>
            </div>
        </Container>
        </main>
      </>
    );
  }
}
export default RentalListingLookup